import React from 'react'

import styled from "styled-components";

const StyledNumberContainer = styled.div`
  background: lightblue;
  flex: 0 0 50px;

  border: 1px solid red;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  padding: 3px;
`;

interface NumberProps {
  readonly Number: number;
  Sorted?: boolean;
};

const NumberColumnContainer = styled.div<NumberProps>`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: ${props => props.Number * 10 + 'px'};
  background: ${props => (props.Sorted !== undefined && props.Sorted) ? 'blue' : 'lightcyan'};

  display: flex;
  flex-direction: column;
  justify-content: flex-end;  
`

const NumberColumnContainerPlaceholder = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  background: lightblue;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;  
`

const NumberLabel = styled.div`
  text-align: center;
`

interface LaneProps {
  readonly On: boolean;
}

const HiLane = styled.div<LaneProps>`
  flex: 0 0 30px;
  text-align: center;
  background: ${props => props.On ? 'red' : 'lightcoral' }
`

const LoLane = styled.div<LaneProps>`
flex: 0 0 30px;
text-align: center;
background: ${props => props.On ? 'red' : 'lightcoral' }
`

const ICountLane = styled.div<LaneProps>`
  flex: 0 0 30px;
  text-align: center;
  background: ${props => props.On ? 'red' : 'lightcoral' }
`

const JCountLane = styled.div<LaneProps>`
  flex: 0 0 30px;
  text-align: center;
  background: ${props => props.On ? 'red' : 'lightcoral' }
`

const PartitionNumberLane = styled.div<LaneProps>`
  flex: 0 0 30px;
  text-align: center;
  background: ${props => props.On ? 'red' : 'lightcoral' }
`

interface IQuickSortNumberContainerProps {
  Number?: number | undefined,
  HI?: number | undefined,
  LO?: number | undefined,
  ICount?: number | undefined,
  JCount?: number | undefined,
  Pivot?: number | undefined,
  PartitionNumber?: number | undefined,
  Index?: number | undefined,
  Sorted?: boolean | undefined,
}

export function QuickSortNumberContainer ({
  Number, HI, LO, ICount, JCount, Pivot, PartitionNumber, Index, Sorted
} : IQuickSortNumberContainerProps) {
  return (
    <StyledNumberContainer>
      {Number ? 
        <NumberColumnContainer Number={Number} Sorted={Sorted}>
          <NumberLabel>{Number}</NumberLabel>
        </NumberColumnContainer> :
        <NumberColumnContainerPlaceholder />
      }
      <HiLane On={HI !== null && HI !== undefined && HI === Index ? true : false}>
        {HI !== null && HI !== undefined && HI === Index && <b>HI: {HI}</b>}
      </HiLane>
      <LoLane On={LO !== null && LO !== undefined && LO === Index ? true : false}>
        {LO !== null && LO !== undefined && LO === Index && <b>LO: {LO}</b>}
      </LoLane>
      <ICountLane On={ICount !== null && ICount !== undefined && ICount === Index ? true : false}>
        {ICount !== null && ICount !== undefined && ICount === Index && <b>I: {ICount}</b>}
      </ICountLane>
      <JCountLane On={JCount !== null && JCount !== undefined && JCount === Index ? true : false}>
        {JCount !== null && JCount !== undefined && JCount === Index && <b>J: {JCount}</b>}
      </JCountLane>
      <PartitionNumberLane On={PartitionNumber !== null && PartitionNumber !== undefined && PartitionNumber === Index ? true : false}/>
    </StyledNumberContainer>
  )
}
